import { render, staticRenderFns } from "./create-leave.vue?vue&type=template&id=c5825a0a&scoped=true&"
import script from "./create-leave.vue?vue&type=script&lang=js&"
export * from "./create-leave.vue?vue&type=script&lang=js&"
import style0 from "./create-leave.vue?vue&type=style&index=0&id=c5825a0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5825a0a",
  null
  
)

export default component.exports